import { render, staticRenderFns } from "./cargoLimitedSelect.vue?vue&type=template&id=13133b4b&scoped=true&"
import script from "./cargoLimitedSelect.vue?vue&type=script&lang=js&"
export * from "./cargoLimitedSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13133b4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13133b4b')) {
      api.createRecord('13133b4b', component.options)
    } else {
      api.reload('13133b4b', component.options)
    }
    module.hot.accept("./cargoLimitedSelect.vue?vue&type=template&id=13133b4b&scoped=true&", function () {
      api.rerender('13133b4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/cargoLimitedSelect.vue"
export default component.exports